import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useRef } from "react";
import { useBoolean } from "usehooks-ts";
import InnerMarkdownHTML from "../../../base/text/inner-markdown-HTML/index.js";
import { nullsToUndefined } from "../../../../helpers/null.js";
import useOnClickOutSideMultipleRef from "../../../../hooks/useOnClickOutSideMultipleRef.js";
import * as S from "./styled.js";
export const DataProtection = ({ infoDataProtection , dataProtection , className , placement ='auto'  })=>{
    const refLink = useRef(null);
    const refTooltip = useRef(null);
    const { value: visibleTooltip , setFalse , toggle  } = useBoolean();
    useOnClickOutSideMultipleRef([
        refTooltip,
        refLink
    ], setFalse);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "DataProtection",
        className: className,
        children: [
            /*#__PURE__*/ _jsx(S.InfoDataProtection, {
                children: infoDataProtection.items.map(({ content , link  })=>/*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            content && /*#__PURE__*/ _jsx(InnerMarkdownHTML, {
                                className: "content-info-data-protection",
                                content: content
                            }),
                            link && /*#__PURE__*/ _jsx("span", {
                                className: "link-info-data-protection",
                                ref: refLink,
                                onClick: toggle,
                                children: link
                            })
                        ]
                    }, content ?? link))
            }),
            visibleTooltip && /*#__PURE__*/ _jsx("div", {
                ref: refTooltip,
                children: /*#__PURE__*/ _jsx(S.DataProtectionTooltip, {
                    placement: placement,
                    isNegative: false,
                    referenceElement: refLink.current,
                    className: "data-protection-tooltip",
                    children: /*#__PURE__*/ _jsxs(S.DataProtectionContentTooltip, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "title-data-protection",
                                children: dataProtection.title
                            }),
                            dataProtection.content && /*#__PURE__*/ _jsx(InnerMarkdownHTML, {
                                tag: "p",
                                className: "content-data-protection",
                                content: dataProtection.content
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                className: "link-data-protection",
                                ...nullsToUndefined(dataProtection.link),
                                children: dataProtection.link?.content
                            })
                        ]
                    })
                })
            })
        ]
    });
};
export default DataProtection;

//# sourceMappingURL=index.js.map